// extracted by mini-css-extract-plugin
export default {"documentTitle":"styles_documentTitle__qGoVY","title":"styles_title__rRknL"};